// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-344cf4f3]{background-color:#f2f5fc!important;padding-bottom:85px;padding-top:67px}.container .list[data-v-344cf4f3]{display:flex;justify-content:space-around;flex-wrap:wrap}.container .list .item[data-v-344cf4f3]{width:18%}.container .list .item .block[data-v-344cf4f3]{margin-top:50px;width:186px;height:244px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
